import * as Yup from "yup";


export const generateValidationSchema = (labels, t, i18n) => {
  const schema = {};

  labels.forEach(({
    name,
    labelName,
    fieldName,
    type,
    required,
    errorMessage,
    options,
    isMultiple,
    minLength,
    minLengthErrorMessage,
    maxLength,
    maxLengthErrorMessage
  }) => {
    if (!name) return;

    let validator;
    const messageToUse = errorMessage ? t(errorMessage) : t("{{field}} is required", { field: t(labelName || name) });

    // If you need to debug translations, you can log here using the passed 't' function:
    // console.log(`For field '${name}', errorMessage key: '${errorMessage}', translated: '${t(errorMessage)}', messageToUse: '${messageToUse}'`);

    if (
      fieldName === 'day-multiselect-dropdown' ||
      fieldName === 'multiselect-dropdown'
    ) {
      validator = Yup.array().of(Yup.string());
      if (required) {
        validator = validator.min(1, messageToUse).required(messageToUse);
      } else {
        validator = validator.nullable();
      }
    } 
    // ADD THIS BLOCK for multiselect-create-dropdown
    else if (fieldName === 'multiselect-create-dropdown') {
      validator = Yup.array()
        .of(
          Yup.object({
            label: Yup.string().required(),
            value: Yup.mixed().required(),
          })
        );
      if (required) {
        validator = validator.min(1, messageToUse).required(messageToUse);
      } else {
        validator = validator.nullable();
      }
    } 
    else if (fieldName === 'date-picker') {
      if (isMultiple) { 
        validator = Yup.array().of(Yup.string());
        if (required) {
          validator = validator.min(1, messageToUse).required(messageToUse);
        } else {
          validator = validator.nullable();
        }
      } else { 
        validator = Yup.string();
        if (required) {
          validator = validator.required(messageToUse);
        } else {
          validator = validator.nullable();
        }
      }
    } 
    else if (fieldName === 'file') {
      if (required) {
        validator = Yup.mixed()
          .required(messageToUse)
          .test(
            "fileCheck",
            messageToUse, 
            value => !!value
          );
      } else {
        validator = Yup.mixed().nullable();
      }
    } else if (fieldName === 'check-box') {
        if (required) {
            validator = Yup.boolean().oneOf([true], messageToUse); 
        } else {
            validator = Yup.boolean();
        }
    }
    else {
      switch (type) {
        case "email":
          validator = Yup.string().email(t("Invalid email format"));
          if (required) {
            validator = validator.required(messageToUse); 
          } else {
            validator = validator.nullable();
          }
          break;
        case "tel":
          validator = Yup.string()
            .matches(/^[0-9]+$/, t("Only digits allowed"))
            .min(5, t("Too short"))
            .max(15, t("Too long"));
          if (required) {
            validator = validator.required(messageToUse); 
          } else {
            validator = validator.nullable().test('empty-or-valid', t("Invalid phone number format"), value => !value || /^[0-9]+$/.test(value));
          }
          break;
        case "select":
          if (required) {
            validator = Yup.mixed().test(
                'is-selected', 
                messageToUse,  
                value => value !== null && value !== undefined && value !== "" 
            ).required(messageToUse); 
          } else {
            validator = Yup.mixed().nullable();
          }
          break;
        case "number":
            validator = Yup.number().typeError(t("Must be a number"));
            if (required) {
                validator = validator.required(messageToUse); 
            } else {
                validator = validator.nullable().transform((value, originalValue) =>
                    String(originalValue).trim() === "" ? null : value
                );
            }
            break;
        default:
          if (required) {
            validator = Yup.string().trim().required(messageToUse);
          } else {
            validator = Yup.string().nullable();
          }

          // Add minLength validation for string types
          if (minLength && typeof minLength === 'number') {
            const minLengthMsg = minLengthErrorMessage
              ? t(minLengthErrorMessage)
              : t("Must be at least {{count}} characters", {
                  field: t(labelName || name),
                  count: minLength,
                });
            validator = validator.min(minLength, minLengthMsg);
          }

          // Add maxLength validation for string types
          if (maxLength && typeof maxLength === 'number') {
            const maxLengthMsg = maxLengthErrorMessage
              ? t(maxLengthErrorMessage)
              : t("{{field}} must be at most {{count}} characters", {
                  field: t(labelName || name),
                  count: maxLength,
                });
            validator = validator.max(maxLength, maxLengthMsg);
          }
      }
    }

    if (validator) {
      schema[name] = validator;
    }
  });

  // Special case: If mobile-box is present, CountryCodeID is required
  const hasMobileBox = labels.some(label => label.fieldName === 'mobile-box');
  if (hasMobileBox) {
    if (!schema['CountryCodeID']) {
        schema['CountryCodeID'] = Yup.mixed().required(t("Country Code is required"));
    }
  }

  return Yup.object().shape(schema);
};
